import { endpoints } from "../config";
import { deleteData, getData, postData, putData } from "./api-utils";

const getAuto = async () => {
  return await getData(endpoints.auto);
};

const postAuto = async (autoFormData) => {
  return await postData(endpoints.auto, autoFormData);
};

const updateAuto = async (id, autoFormData) => {
  return await putData(endpoints.auto + "/" + id, autoFormData);
};

const deleteAuto = async (autoId) => {
  return await deleteData(endpoints.auto + "/" + autoId);
};

export { getAuto, postAuto, updateAuto, deleteAuto };
